import { axiosGet, axiosPost, handleOnError } from "../utils/api";

class CasesService {
  async fetchAll() {
    try {
      let response = await axiosGet("cases/fetch/all");
      return response.data;
    } catch (error) {
      return await handleOnError(error);
    }
  }
  async fetchByCaseId(id) {
    try {
      let response = await axiosGet(`cases/fetch/${id}`);
      return response.data;
    } catch (error) {
      return await handleOnError(error);
    }
  }

  async save(url,data) {
    try {
      let response = await axiosPost(url, data);
      return response.data;
    } catch (error) {
      return await handleOnError(error);
    }
  }

  async bulkRemove(data) {
    try {
      let response = await axiosPost("cases/bulkdelete", data);
      return response.data;
    } catch (error) {
      return await handleOnError(error);
    }
  }
  async bulkEdit(data) {
    try {
      let response = await axiosPost("cases/bulkedit", data);
      return response.data;
    } catch (error) {
      return await handleOnError(error);
    }
  }
  async fetchByWeeklyGroupData(params={}){
    try {
      let response = await axiosGet("cases/fetch/weeklygroup",params);
      return response.data;
    } catch (error) {
      return await handleOnError(error);
    }
  }
  async search(params={}){
    try{
      let response = await axiosGet('cases/search',params)
      return response.data
    }catch(error){
        return await handleOnError(error);
    }
  }
}

export default new CasesService();
